import { withErrorBoundary } from '../../../components/ErrorBoundary';
import { memoWithDisplayName } from '../../../nav-ui-components/utils/memoWithDisplayName';
import { usePublicApi } from '../hooks/usePublicApi';

// Added component to make it easier to wrap it in an error boundary
export const _PublicAPI = () => {
  usePublicApi();
  return null;
};
export const PublicAPI = withErrorBoundary(memoWithDisplayName('PublicAPI', _PublicAPI), {
  boundaryName: 'PublicAPI'
});